var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTarget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#target_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.982.75a.93.93 0 0 1 .682.501l.695 1.39 1.39.695a.928.928 0 0 1 .241 1.488l-2.5 2.5a.93.93 0 0 1-.657.272h-2.115l-3.061 3.061a.929.929 0 1 1-1.314-1.314l3.062-3.061V4.167c0-.247.098-.483.272-.657l2.5-2.5a.93.93 0 0 1 .805-.26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 2.595A7.405 7.405 0 1 0 17.405 10a.929.929 0 0 1 1.857 0A9.262 9.262 0 1 1 10 .738a.929.929 0 0 1 0 1.857"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 6.762A3.238 3.238 0 1 0 13.238 10a.929.929 0 1 1 1.857 0A5.095 5.095 0 1 1 10 4.905a.929.929 0 0 1 0 1.857"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "target_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgTarget.displayName = "SvgTarget";
export { SvgTarget as ReactComponent };
export default SvgTarget;